import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled';

/**
 * Renders the chat-input footer row when voice dictation is disabled by the
 * consumer or by experiment rollout.
 *
 * This file does NOT import the voice-enabled footer or any `@atlassian/ai-audio`
 * entry point, which keeps the audio chunk out of the chat-input critical path
 * for non-voice users.
 *
 * IMPORTANT: do not import from `@atlassian/ai-audio` (or from the voice
 * enabled footer) in this file - that would defeat the lazy-load.
 */

export type DisabledVoiceFooterRowProps = {
	/** Content rendered on the left side of the footer row (action buttons + chat-mode menu). */
	promptControlsSlot: React.ReactNode;
	/** Content rendered before the submit button in the right-side actions column. */
	actionsBeforeSubmitSlot: React.ReactNode;
	/** The submit button itself. */
	submitButtonSlot: React.ReactNode;
};

const DisabledVoiceFooterRow: React.FC<DisabledVoiceFooterRowProps> = ({
	promptControlsSlot,
	actionsBeforeSubmitSlot,
	submitButtonSlot,
}) => (
	<>
		{promptControlsSlot}
		<Inline alignBlock="center" space="space.050">
			{actionsBeforeSubmitSlot}
			{submitButtonSlot}
		</Inline>
	</>
);

export default DisabledVoiceFooterRow;
